import { useEffect, useState } from "react";
import styles from "../style/blog.module.css";
import moment from "moment/moment";
import { GetApi, PostApi } from "../api/api-service";
import { API_Path, imgBaseUrl } from "../Const";
import { Link } from "react-router";
import noBlogImg from "../images/no_blog.jpg";
import { MdDateRange } from "react-icons/md";
import ProjectLoader from "../components/loader/ProjectLoader";

// ── COMPONENT ─────────────────────────────────────────────
export default function BlogPage() {
    const [activeTab, setActiveTab] = useState(0);
    const [option, setOption] = useState({ sizePerPage: 24, search: "", totalRecord: 0, page: 0, sort: "created", order: "ASC", startDate: "", endate: "" });
    const [isLoader, setIsLoader] = useState({ blog: false, tranding: false, category: false });
    const [blogList, setBlogList] = useState([]);
    const [blogTrend, setBlogTrend] = useState([]);
    const [blogCategory, setBlogCategory] = useState([]);

    const dayjsFormat = (date) => {
        return date ? moment(date).format("YYYY-MM-DD") : null;
    };

    useEffect(() => {
        fatchBlogList();
        fatchBlogTrend();
        fatchBlogCategory();
    }, []);
    const fatchBlogList = async () => {
        const data = {
            searchValue: option.search ? option.search : null,
            pageNumber: option.page + 1,
            pageSize: option.sizePerPage,
            startDate: option.startDate ? dayjsFormat(option.startDate) : null,
            endDate: option.endate ? dayjsFormat(option.endate) : null,
        };
        try {
            setIsLoader({ blog: true, tranding: false, category: false });
            let res = await PostApi(API_Path.blogList, data);
            if (res && res.data.success) {
                let data = res.data.data;
                let filterData = data.filter((item) => item.isActive).sort((a, b) => a.orderRank - b.orderRank);
                setBlogList(filterData);
                setOption({ ...option, totalRecord: res.data.totalRecords });
            }
            setIsLoader({ blog: false, tranding: false, category: false });
        } catch (error) {
            setIsLoader({ blog: false, tranding: false, category: false });
        }
    };
    const fatchBlogTrend = async () => {
        try {
            setIsLoader({ blog: false, tranding: true, category: false });
            let res = await GetApi(API_Path.blogTrending);
            if (res && res.data.success) {
                setBlogTrend(res.data.data);
            }
            setIsLoader({ blog: false, tranding: false, category: false });
        } catch (error) {
            setIsLoader({ blog: false, tranding: false, category: false });
        }
    };
    const fatchBlogCategory = async () => {
        try {
            let res = await GetApi(API_Path.blogCategory);
            if (res && res.data.success) {
                setBlogCategory(res.data.data);
            }
        } catch (error) {}
    };
    const loaders = Array.from({ length: 8 });

    const fatchCategoryWiseBlog = async (id) => {
        const data = {
            searchValue: option.search ? option.search : null,
            pageNumber: option.page + 1,
            pageSize: option.sizePerPage,
            startDate: option.startDate ? dayjsFormat(option.startDate) : null,
            endDate: option.endate ? dayjsFormat(option.endate) : null,
        };
        try {
            setIsLoader({ blog: true, tranding: false, category: true });
            let res = await PostApi(`${API_Path.categoryWiseBlog}${id}?api-version=1`, data);
            if (res && res.data.success) {
                let data = res.data.data;
                let filterData = data.filter((item) => item.isActive);
                setBlogList(filterData);
                setOption({ ...option, totalRecord: res.data.totalRecords });
            }
            setIsLoader({ blog: false, tranding: false, category: false });
        } catch (error) {
            setIsLoader({ blog: false, tranding: false, category: false });
        }
    };
    const handleCategory = (id) => {
        fatchCategoryWiseBlog(id);
        setActiveTab(id);
    };
    return (
        <div>
            {/* ── HERO ── */}
            <section className={styles.hero}>
                <div className="container">
                    <div className="row">
                        <div className={styles.heroContent}>
                            <p className={styles.heroEyebrow}>Blog &amp; Insights</p>
                            <h1 className={styles.heroTitle}>Insights that help you find the right property</h1>
                            <p className={styles.heroSub}>Expert advice, market updates and home inspiration to help you make smarter property decisions.</p>
                            {/* <div className={styles.heroSearchRow}>
                                <input className={styles.heroSearchInput} placeholder="Search for articles..." />
                                <button className={styles.heroSearchBtn}>🔍 Search</button>
                            </div> */}
                        </div>
                        <div className={styles.heroImageWrap}>
                            <img className={styles.heroImage} src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=900&q=85" alt="Dubai skyline" />
                            <div className={styles.heroGradientOverlay} />
                        </div>
                    </div>
                </div>
            </section>

            {/* ── TABS ── */}
            <div className={styles.tabsBar}>
                <div className="container">
                    <ul className={styles.tabsList}>
                        <li className={`${styles.tabItem} ${activeTab === 0 ? styles.active : ""}`} onClick={() => fatchBlogList()}>
                            All Articles
                        </li>
                        {blogCategory.map((t, i) => (
                            <li key={i} className={`${styles.tabItem} ${activeTab === t.id ? styles.active : ""}`} onClick={() => handleCategory(t.id)}>
                                <span className={styles.tabIcon}>
                                    <img src={`${imgBaseUrl}${t.iconUrl}`} alt={t.name} />
                                </span>
                                {t.name}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* ── MAIN BODY ── */}
            <div className={styles.pageBody}>
                <div className="container">
                    <div className={styles.secRow}>
                        <main>
                            {/* Latest Articles */}
                            <section className={styles.latestSection}>
                                <h2 className={styles.sectionTitle}>Latest Articles</h2>
                                {isLoader.blog ? (
                                    <div className={styles.articleGrid}>
                                        {loaders.map((_, index) => (
                                            <div className={`${styles.articleCard} p-2`} key={index}>
                                                <ProjectLoader />
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className={styles.articleGrid}>
                                        {blogList.map((a) => (
                                            <div className={styles.articleCard} key={a.id}>
                                                <img
                                                    className={styles.articleThumb}
                                                    src={a.blogImageUrl ? `${imgBaseUrl}${a.blogImageUrl}` : noBlogImg}
                                                    alt={a.name}
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null; // prevents looping
                                                        currentTarget.src = { noBlogImg };
                                                    }}
                                                />
                                                <div className={styles.articleBody}>
                                                    <span className={`${styles.tagBadge} ${styles[a.categoryName]}`}>{a.categoryName}</span>
                                                    <h4 className={`${styles.articleTitle} ${styles.line_clamp}`}>{a.name}</h4>
                                                    <p className={`${styles.articleExcerpt} ${styles.line_clamp}`}>{a.shortDescription}</p>
                                                    <div className={styles.articleMeta}>
                                                        <span>
                                                            <MdDateRange /> {a.created}
                                                        </span>
                                                        {/* <span>🕐 {a.read}</span> */}
                                                    </div>
                                                    <div className={styles.articleRead}>
                                                        <Link to={`/blog/${a.nameUrl}/${a.id}`}>Read More →</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </section>
                        </main>

                        {/* SIDEBAR */}
                        <aside className={styles.sidebar}>
                            {/* Trending */}
                            <div className={`${styles.sideCard} ${styles.sideMargin}`}>
                                <h3 className={styles.sideTitle}>Trending Now</h3>
                                <ul className={styles.trendingList}>
                                    {blogTrend.map((t, i) => (
                                        <li key={t.id}  className={styles.trendingItem}>
                                            <Link to={`/blog/${t.nameUrl}/${t.id}`}  className={styles.trendingItem}>
                                                <img
                                                    className={styles.trendingThumb}
                                                    src={t.blogImageUrl ? `${imgBaseUrl}${t.blogImageUrl}` : noBlogImg}
                                                    alt={t.name}
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null; 
                                                        currentTarget.src = { noBlogImg };
                                                    }}
                                                />
                                                <div className={styles.trendingInfo}>
                                                    <p className={styles.trendingTitle}>{t.name}</p>
                                                    <p className={styles.trendingDate}>
                                                        <MdDateRange /> {t.created}
                                                    </p>
                                                </div>
                                                <span className={styles.trendingNum}>{i + 1}</span>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Categories */}
                            {/* <div className={styles.sideCard}>
                                <h3 className={styles.sideTitle}>Popular Categories</h3>
                                <ul className={styles.catList}>
                                    {blogCategory.map((c) => (
                                        <li key={c.name} className={styles.catItem}>
                                            <span className={styles.catLeft}>
                                                <span className={styles.tabIcon}>
                                                    <img src={`${imgBaseUrl}${c.iconUrl}`} alt={c.name} />
                                                </span>
                                                {c.name}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div> */}

                            {/* CTA */}
                            <div className={styles.ctaCard}>
                                <h3 className={styles.ctaTitle}>Thinking of buying or investing?</h3>
                                <p className={styles.ctaSub}>Our property experts are here to help you make the right move.</p>
                                <Link to="/agents">
                                    <button className={styles.ctaBtn}>Talk to an Experts →</button>
                                </Link>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </div>
    );
}
